<template>
    <v-card flat
            tile
            class="rang-widget mb-8"
            style="border-left-width: 10px; border-left-style: solid; transition: border-left-color .2s"
            :style="{ 'border-left-color': borderColor }">
        <heading-section classes="d-flex pl-5 pr-7 pt-3">
            <v-icon class="mr-3">mdi-podium-silver</v-icon>
            <span v-html="$options.filters.master(`${$vuetify.lang.t('$vuetify.page_rang_detail.title')}`)"></span>
        </heading-section>

        <div class="pl-5 pr-7 pt-3 pb-6">
            <v-tabs @change="handleTabUpdate"
                    :value="filterAchievementTab"
                    :show-arrows="false"
                    background-color="transparent"
                    height="40">
                <v-tab v-for="achievement in achievements"
                       :key="achievement.id"
                       class="px-2">
                    {{ achievement.brand.name }}
                </v-tab>
            </v-tabs>

            <v-tabs-items @change="handleTabUpdate"
                          :value="filterAchievementTab"
                          class="mt-3 mb-2">
                <v-tab-item v-for="achievement in achievements"
                            :key="achievement.id"
                            background-color="transparent">
                    <div>
                        <div class="d-flex flex-column align-center mb-3">
                            <v-img aspect-ratio="1"
                                   contain
                                   max-width="75px"
                                   width="100%"
                                   class="mb-1"
                                   :src="achievement.actual_rank.icon"
                                   v-if="achievement.actual_rank.icon"></v-img>
                            <div class="text-uppercase mt-3 body-1 d-flex align-center"
                                 :class="{ 'font-weight-bold': achievement.actual_rank.id === 1 }">
                                <span style="line-height: normal"
                                      v-html="$options.filters.master(achievement.actual_rank.name[$vuetify.lang.current]
                                    ? achievement.actual_rank.name[$vuetify.lang.current]
                                    : achievement.actual_rank.name)"></span>
                            </div>

                            <div v-if="achievement.actual_rank.name === 'Member'" class="mt-4 text-center"
                                 v-html="$vuetify.lang.t('$vuetify.rank.rank_rise_1', $options.filters.master(achievement.next_rank.name))"></div>
                            <div v-else-if="achievement.actual_rank.name !== 'Member' && achievement.actual_rank.name !== 'Ultimate Master'" class="mt-4 text-center mb-3"
                                 v-html="$vuetify.lang.t('$vuetify.rank.rank_rise_2', $options.filters.master(achievement.next_rank.name))"></div>
                            <div v-else class="mt-4 text-center mb-3"
                                 v-html="$vuetify.lang.t('$vuetify.rank.rank_preservation', $options.filters.master(achievement.next_rank.name))"></div>

                        </div>

                        <pane class="d-flex align-center pa-2 pane--active" :class="getActiveClass(achievement.level_system.from, achievement.level_system.steps[getCurrentStep(achievement.level_system) - 1].state)">
                            <div>
                                <div>
                                    {{ $vuetify.lang.t('$vuetify.rank.step', getCurrentStep(achievement.level_system)) }}
                                </div>
                                <div class="level-system__retry text--grey"
                                     v-if="achievement.level_system.steps[getCurrentStep(achievement.level_system) - 1].repeatLevel">{{ $vuetify.lang.t('$vuetify.rank.retry') }}
                                </div>
                            </div>

                            <label-badge class="ml-auto"
                                         :state="achievement.level_system.steps[getCurrentStep(achievement.level_system) - 1].state"
                                         :step="achievement.level_system.steps[getCurrentStep(achievement.level_system) - 1].name"
                                         :date="achievement.level_system.steps[getCurrentStep(achievement.level_system) - 1].availableDate"
                                         :from="achievement.level_system.from"
                                         :title="resolveRankTranslation(achievement.level_system.steps[getCurrentStep(achievement.level_system) - 1].state, achievement.level_system.steps[getCurrentStep(achievement.level_system) - 1].availableDate)"></label-badge>
                        </pane>

                        <v-divider class="mt-2 mb-4" />

                        <div v-if="achievement.actual_rank.name !== 'Member'" class="mb-4 font-p2" v-html="$options.filters.master($vuetify.lang.t('$vuetify.rank.collect', getCurrentStep(achievement.level_system), '01.01', `31.12.${currentYear}`))"></div>
                        <div v-else class="mb-4 font-p2" v-html="$options.filters.master($vuetify.lang.t('$vuetify.rank.collect2', '01.01', `31.12.${currentYear}`))"></div>

                        <pane class="py-3 px-6 mb-3">
                            <h2 class="font-h2 font-weight-bold text-center mb-2"
                                v-html="$options.filters.master($vuetify.lang.t('$vuetify.rank.achievements'))"></h2>
                            <v-row justify="center">
                                <v-col :cols="achievementItem.achievement.identifier === 'ihk' ? 'auto' : 4" v-for="(achievementItem, index) in achievement.achievements"
                                       :key="achievementItem.id">
                                    <router-link class="text-decoration-none d-flex flex-column justify-center align-center px-1"
                                                 :class="{ 'white--text': achievementItem.completed, 'text--secondary': !achievementItem.completed }"
                                                 :to="{ ...rangDetailUrl, params: { achievement: index }}">
                                        <v-progress-circular :rotate="90"
                                                             :size="65"
                                                             :width="3"
                                                             :value="calcProgress(achievementItem)"
                                                             color="primary">
                                            <v-avatar size="60">
                                                <v-img :src="getMedalImage(achievementItem)"
                                                       :style="{ opacity: !achievementItem.completed ? .7 : 1 }"
                                                       aspect-ratio="1"
                                                       max-width="60px"></v-img>
                                            </v-avatar>
                                        </v-progress-circular>
                                        <div class="body-1 text-center text-uppercase mt-2"
                                             v-html="achievementItem.achievement.name[$vuetify.lang.current]
                                                            ? achievementItem.achievement.name[$vuetify.lang.current]
                                                            : achievementItem.achievement.name"></div>
                                        <div class="headline text-center font-weight-bold">{{
                                                calcProgress(achievementItem)
                                                                                           }}%
                                        </div>
                                    </router-link>
                                </v-col>
                            </v-row>
                        </pane>
                        <pane class="px-6 py-3 mb-3" v-if="achievement.actual_rank.name !== 'Member'">
                            <div class="d-flex flex-column flex-nowrap">
                                <h2 class="font-h2 font-weight-bold text-center mb-2"
                                    v-html="$options.filters.master($vuetify.lang.t('$vuetify.rank.masterpoints'))"></h2>

                                <mp-multi-progress class="mb-2"
                                                   :percent="achievement.masterpoints_target"
                                                   :attribute-color-mapping="attributeColorMapping"
                                                   :items="achievement.masterpoints"></mp-multi-progress>

                                <i18n path="$vuetify.page_rang_detail.actual"
                                      class="d-flex align-center mx-auto">
                                    <div class="d-flex align-baseline mx-1 error--text"
                                         :class="{ 'success--text': achievement.masterpoints.sum_points >= achievement.masterpoints_target }">
                                                    <span class="headline font-weight-bold">
                                                        {{ achievement.masterpoints.sum_points }}/
                                                    </span>
                                        <span>{{ achievement.masterpoints_target }}</span>
                                    </div>
                                </i18n>
                            </div>
                        </pane>


                    </div>
                </v-tab-item>
            </v-tabs-items>

            <v-btn block
                   tile
                   depressed
                   color="primary darken-1"
                   :to="rangDetailUrl"
                   id="ranks-detail-button">
                {{ $vuetify.lang.t('$vuetify.buttons.details') }}
            </v-btn>
        </div>

    </v-card>
</template>

<script>
// utils
import {medalImage} from '../../utils/helper';
import {ROUTE_RANG} from '../../utils/constants';
// mixins
import achievementTab from '../../mixins/achievementTab';
// components
import MpMultiProgress from '../MpMultiProgress';
import Pane from '../Pane';
import LabelBadge from '../LabelBadge';

export default {
    name: 'widget-rangs',
    components: {
        MpMultiProgress,
        Pane,
        LabelBadge,
    },
    mixins: [
        achievementTab,
    ],
    data() {
        return {
            requiredYear: 2022,
            borderColor: '#0089bf',
            currentYear: new Date().getFullYear(),
        };
    },
    methods: {
        resolveRankTranslation(state, date) {
            if (state === 'not_available') {
                return this.$vuetify.lang.t(`$vuetify.rank.from`, this.$options.filters.date(date));
            } else if (state === 'down') {
                return this.$vuetify.lang.t(`$vuetify.rank.states.in_progress`);
            } else {
                return this.$vuetify.lang.t(`$vuetify.rank.states.${state}`);
            }
        },
        getMedalImage(achievementItem) {
            const item = achievementItem.achievement.identifier ? achievementItem.achievement.identifier : achievementItem.achievement.name.toLowerCase();
            return medalImage(item, achievementItem.completed);
        },
        getMissingCount(achievements) {
            return achievements.length - achievements.reduce((accumulator, currentValue) => {
                return accumulator + currentValue.completed;
            }, 0);
        },
        calcProgress(achievement) {
            const calc = achievement.progress / achievement.target * 100;
            return calc > 100 ? 100 : Math.round(calc);
        },
        handleTabUpdate(e) {
            this.borderColor =
                this.achievements.length > 0 &&
                this.achievements[e] &&
                this.achievements[e].actual_rank
                    ? this.achievements[e].actual_rank.color
                    : this.borderColor;
            this.setFilter({
                item: 'filterAchievementTab',
                value: e,
            });
        },
        calcPercentage(productPrice, max) {
            const percentage = productPrice / max * 100;
            return percentage >= 100 ? 100 : percentage;
        },
        getCurrentStep(levelSystem) {
            let currStep = 1;
            if (levelSystem.steps && levelSystem.steps.length > 1) {
                if (levelSystem.steps[0].state === 'succeeded') {
                    currStep = 2;
                }
            }
            return currStep;
        },
        getActiveClass(rank, state) {
            const classes = [];
            if (state === 'rank_saved' && rank === 'ultimate_master') {
                classes.push('pane--active-succeeded');
            } else {
                classes.push(`pane--active-${state}`)
            }
            return classes;
        }
    },
    computed: {
        attributeColorMapping() {
            return {
                trade_fairs: '#be0443',
                trainings: '#0089bf',
                sold_vehicles: '#004a79',
                ihk_premium_seller: '#e5b900',
                google_rating: '#2fc156',
            };
        },
        maximumMasterpoints() {
            if (new Date().getFullYear() === 2021) {
                return 80;
            }
            return 100;
        },
        rangDetailUrl() {
            return {name: ROUTE_RANG};
        },
    },
    mounted() {
        this.borderColor =
            this.achievements.length > 0 &&
            this.achievements[this.filterAchievementTab] &&
            this.achievements[this.filterAchievementTab].actual_rank
                ? this.achievements[this.filterAchievementTab].actual_rank.color
                : this.borderColor;
    },
};
</script>
